<template>
  <main>
    <top-section title="Зв'яжіться з нами" :breadcrumb="breadcrumb" />
    <section class="map mt-5">
      <div class="container">
        <div class="map__wrapper">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1287.6762314976938!2d36.71294465824718!3d49.7982409948477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDnCsDQ3JzUzLjciTiAzNsKwNDInNTAuNSJF!5e0!3m2!1sru!2sua!4v1606300728518!5m2!1sru!2sua"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          ></iframe>
        </div>
      </div>
    </section>
    <section class="contact-section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="contact-title">Будемо на зв'язку</h2>
          </div>
          <div class="col-lg-7">
            <form
              class="form-contact contact_form"
              method="post"
              id="contactForm"
              novalidate="novalidate"
              @submit.prevent="submitContactForm"
            >
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <input
                      v-model="form.name"
                      class="form-control valid"
                      name="name"
                      id="name"
                      type="text"
                      onfocus="this.placeholder = ''"
                      onblur="this.placeholder = 'Введіть ім\'я'"
                      placeholder="Введіть ім'я"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <input
                      v-model="form.email"
                      class="form-control valid"
                      name="email"
                      id="email"
                      type="email"
                      onfocus="this.placeholder = ''"
                      onblur="this.placeholder = 'Введіть адресу електронної пошти'"
                      placeholder="Email"
                      required
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <input
                      v-model="form.subject"
                      class="form-control"
                      name="subject"
                      id="subject"
                      type="text"
                      onfocus="this.placeholder = ''"
                      onblur="this.placeholder = 'Введіть тему'"
                      placeholder="Введіть тему"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <textarea
                      v-model="form.message"
                      class="form-control w-100"
                      name="message"
                      id="message"
                      cols="30"
                      rows="9"
                      onfocus="this.placeholder = ''"
                      onblur="this.placeholder = 'Введіть повідомлення'"
                      placeholder="Введіть повідомлення"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="form-group mt-3">
                <button
                  type="submit"
                  class="button button-contactForm boxed-btn"
                >
                  надіслати
                </button>
              </div>
            </form>
          </div>
          <div class="col-lg-4 offset-lg-1">
            <div class="media contact-info">
              <span class="contact-info__icon"><i class="ti-home"></i></span>
              <div class="media-body">
                <h3>63525</h3>
                <h3>КНЗ «Центр позашкільної освіти»</h3>
                <h3>Пров. Пушкіна, 2а,</h3>
                <h3>смт Малинівка,</h3>
                <h3>Чугуївський район,</h3>
                <h3>Харківська область,</h3>
                <h3>Україна</h3>
              </div>
            </div>
            <div class="media contact-info">
              <span class="contact-info__icon"><i class="ti-tablet"></i></span>
              <div class="media-body">
                <h3><a href="tel:380667348785">+38 (066)-734-87-85</a></h3>
                <p>Контактна особа:<br />директор Кисіль Ольга Вікторівна</p>
              </div>
            </div>
            <div class="media contact-info">
              <span class="contact-info__icon"><i class="ti-email"></i></span>
              <div class="media-body">
                <h3><a href="mailto:knzcpo@ukr.net">knzcpo@ukr.net</a></h3>
                <p>Надішліть нам свій запит у будь-який час!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Contact Area End -->
  </main>
</template>

<script>
import TopSection from "@/components/TopSection";

export default {
  name: "Contact",
  components: { TopSection },
  data: () => ({
    form: {
      name: "",
      email: "",
      subject: "",
      message: ""
    },
    breadcrumb: [
      {
        title: "Головна",
        url: "/"
      },
      {
        title: "Контакти",
        url: "/contact"
      }
    ]
  })
};
</script>

<style scoped></style>
